// Marks the site header with data-scrolled once the page has left the very top, so the
// home page header can switch from transparent (over the hero) to filled. Reads the real
// scroll position (passive scroll listener, rAF-throttled) so a stale observer state can't
// leave the header filled at the top of the page.
const header = document.querySelector('[data-site-header]');

if (header && !header.dataset.scrollWatch) {
  header.dataset.scrollWatch = '';
  let queued = false;
  const update = () => {
    queued = false;
    header.toggleAttribute('data-scrolled', window.scrollY > 8);
  };
  const queue = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(update);
  };
  update();
  window.addEventListener('scroll', queue, { passive: true });
  window.addEventListener('pageshow', update);
}

// Home page: the sticky header is pulled over the hero by its own height (CSS var --site-header-h on the header).
if (header && header.hasAttribute('data-transparent') && !header.dataset.sizeWatch) {
  header.dataset.sizeWatch = '';
  new ResizeObserver(([entry]) => {
    const height = entry.borderBoxSize?.[0]?.blockSize ?? header.offsetHeight;
    header.style.setProperty('--site-header-h', `${Math.round(height)}px`);
  }).observe(header);
}

// Home hero search: when its results panel opens (s-live-form applied results), scroll the page just enough that the
// panel is fully visible, without pushing the search field under the sticky header. Smooth unless reduced motion.
const heroSearch = document.querySelector('.hero-search');
if (heroSearch && !heroSearch.dataset.scrollWatch) {
  heroSearch.dataset.scrollWatch = '';
  heroSearch.addEventListener('s-live-form:updated', () => {
    requestAnimationFrame(() => {
      const panel = heroSearch.querySelector('.hero-search-panel');
      const field = heroSearch.querySelector('form');
      const input = heroSearch.querySelector('input[name="q"]');
      if (!panel || !field || !panel.querySelector('[data-hs-filled]') || document.activeElement !== input) return;
      const panelBottom = panel.getBoundingClientRect().bottom;
      const fieldTop = field.getBoundingClientRect().top;
      const headerBottom = header ? header.getBoundingClientRect().bottom : 0;
      const needed = panelBottom - window.innerHeight + 24;
      const room = fieldTop - headerBottom - 16;
      const distance = Math.min(needed, room);
      if (distance <= 0) return;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollBy({ top: distance, behavior: reduce ? 'auto' : 'smooth' });
    });
  });
}
